module.exports = __webpack_public_path__ + "static/media/ehealth_bpbg_banner_mobile.3fe1a9a9.jpg";